import React from 'react';
import ModalContainer from 'components/shared/modal/modal_container';
import { Modal, Button, ButtonGroup } from 'ui';
import DemonstrationGradersCollection from './DemonstrationGradersCollection';

class DemonstrationGradersModal extends React.Component {
  render() {
    const { closeModal, graders } = this.props;
    return (
      <ModalContainer onEscape={closeModal}>
        <Modal shown className="LessonVersionModal-wrapper bg-gray-lightest">
          <Modal.Content className="d-f fd-c">
            <h1 className="LessonVersionModal-title pb-24 ff-ss fw-n">
              {`${t('demonstrations.all_graders')}${
                graders && ` (${graders.length})`
              }`}
            </h1>
            <DemonstrationGradersCollection {...this.props} />
          </Modal.Content>
          <ButtonGroup alignEnd className="pb-16 pr-32 pt-8">
            <Button onClick={closeModal}>{t('common.close')}</Button>
          </ButtonGroup>
        </Modal>
      </ModalContainer>
    );
  }
}

export default DemonstrationGradersModal;
